import { render, staticRenderFns } from "./WelfareShiftTable.vue?vue&type=template&id=d96e6bfc&scoped=true"
import script from "./WelfareShiftTable.vue?vue&type=script&lang=js"
export * from "./WelfareShiftTable.vue?vue&type=script&lang=js"
import style1 from "./WelfareShiftTable.vue?vue&type=style&index=1&id=d96e6bfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96e6bfc",
  null
  
)

export default component.exports